import React from 'react';

import Aelectricinjecton from './Aelectricinjecton';
import Plasticcompo from './Plasticcompo';
import Featureseng from './Featureseng';
import Clampings from './Clampings';
import Injectionsy from './Injectionsy';


const Allelectricinj = () => {
  return (
    <div>
     <Aelectricinjecton />
            < Plasticcompo />
            < Featureseng />
            <Clampings />
            <Injectionsy />
    </div>
  );
};

export default Allelectricinj;
